var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.892,
    height: 49.595,
    viewBox: "0 0 68.892 49.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_158",
    x: 0,
    y: 11.595,
    width: 68.892,
    height: 38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(-10 -452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M4.477,0H46.461c2.444,0,4.425,2.421,4.425,5.409V30.591C50.886,33.579,48.9,36,46.461,36H4.477C2.033,36,.052,33.579.052,30.591V5.409C.052,2.421,2.033,0,4.477,0Z",
    transform: "translate(19.006 452)",
    fill: "rgba(0,6,60,0.8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10, 452)",
    filter: "url(#Path_158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158-2",
    "data-name": "Path 158",
    d: "M4.425,0H46.466a4.435,4.435,0,0,1,4.425,4.444V15.556A4.435,4.435,0,0,1,46.466,20H4.425A4.435,4.435,0,0,1,0,15.556V4.444A4.435,4.435,0,0,1,4.425,0Z",
    transform: "translate(9 17.6)",
    fill: "#00063c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(7.611 322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_1",
    "data-name": "Union 1",
    transform: "translate(5.389 143)",
    fill: "#66cb35",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 11 L 10 11 L 0 11 L -1 11 L -1 10 L -1 0 L -1 -1 L 0 -1 L 10 -1 L 11 -1 L 11 0 L 11 10 L 11 11 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 10 L 10 10 L 10 0 L 0 0 M 0 -2 L 10 -2 C 11.10457038879395 -2 12 -1.104570388793945 12 0 L 12 10 C 12 11.10457038879395 11.10457038879395 12 10 12 L 0 12 C -1.104570388793945 12 -2 11.10457038879395 -2 10 L -2 0 C -2 -1.104570388793945 -1.104570388793945 -2 0 -2 Z",
    stroke: "none",
    fill: "#f4f4f3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishMarker);
export default __webpack_public_path__ + "static/media/finish_marker.139b32ac8b4a66157c7760ce7bbe75c3.svg";
export { ForwardRef as ReactComponent };